import React from 'react'
import { NavLink } from 'react-router-dom'

export const StaticsHeader = () => {
  return (
    <>

      {/* <!-- Navigation Section --> */}
      <div className="header box-shadow1" id="myHeader">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light white-bg px-0">
            <a className="nav-link px-0" routerLink="/Home"> <img src="clientassets/img/logo_colored.png" className="img-fluid img-size" /> </a>
            <button className="navbar-toggler ml-auto my-3 my-lg-0" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            {/* <!-- buttons ends here --> */}

            <div className="collapse navbar-collapse" id="navbarNavDropdown">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item " routerLinkActive="active" >
                  <NavLink className="nav-link link header-css" to="/statichome"> Home </NavLink>
                </li>
                {/* <!-- Home --> */}
                <li className="nav-item" routerLinkActive="active">
                  <NavLink className="nav-link link header-css" to="/solution" > The Solution </NavLink>
                </li>
                {/* <!-- Solution --> */}
                <li className="nav-item" routerLinkActive="active">
                  <NavLink className="nav-link link header-css" to="/apps" > The Apps </NavLink>
                </li>
                {/* <!-- The App --> */}
                <li className="nav-item" routerLinkActive="active">
                  <NavLink className="nav-link link header-css" to="/pricing" > Pricing </NavLink>
                </li>
                {/* <!-- Pricing --> */}
                <li className="nav-item" routerLinkActive="active">
                  <NavLink className="nav-link link header-css" to="/contact-us" > Contact us </NavLink>
                </li>
                {/* <!-- Contatc us --> */}
                <li className="nav-item" routerLinkActive="active">
                  <NavLink className="nav-link btn btn-blue-grad px-4 text-capitalize header-css" to="/demo" > Demo </NavLink>
                </li>
                {/* <!-- Demo --> */}
                <li className="nav-item" routerLinkActive="active">
                  <NavLink className="nav-link btn btn-green-grad px-4 text-capitalize header-css" to="/login" > Login </NavLink>
                </li>
                {/* <!-- Login --> */}
              </ul>
            </div>
            {/* <!-- end of navbar-collapse --> */}
          </nav>
        </div>
        {/* <!-- end of container --> */}
      </div>
      {/* <!-- End of Navigation Section --> */}

    </>
  )
}
